/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
import babelPlugin from 'prettier/plugins/babel';
import estreePlugin from 'prettier/plugins/estree';
import * as prettier from 'prettier/standalone';

import { StepConverter } from '../managers/StepConverter';

import { Step as UIStep } from '@/pages/projects/LiveAgentTypes';

/**
 * Generate formatted block code from a list of steps and argument names.
 * This was previously an inline helper inside `useBlockOperations`.
 */
export const generateBlockCode = async (
    blockName: string,
    blockSteps: UIStep[],
    blockDefArgs: string[],
): Promise<string> => {
    // Convert blockDefArgs to parameter names string
    const paramNames = blockDefArgs.join(', ');

    // Generate the inner code using StepConverter
    const innerCode =
        blockSteps.length > 0 ? StepConverter.stepsToCode(blockSteps) : '// Block implementation goes here';

    // Build the complete block code (unformatted)
    const unformattedBlockCode = `Heal.blocks.${blockName} = async (${paramNames}) => {\n${innerCode}\n};`;

    // Format with prettier for consistent style
    try {
        const blockCode = await prettier.format(unformattedBlockCode, {
            parser: 'babel',
            plugins: [babelPlugin as any, estreePlugin as any],
            semi: true,
            singleQuote: true,
            tabWidth: 4,
            trailingComma: 'none',
            printWidth: 80,
        });

        return blockCode;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Prettier formatting failed, returning unformatted block code:', error);
        return unformattedBlockCode;
    }
};
